import React from "react";
import "./CourseDetailHero.css";
import { scrollToElementById } from "../../../../utils/scrollToId";

const CourseDetailHero = ({ course, heroImage }) => {
  const handleViewDetails = () => {
    scrollToElementById("course-detail-program");
  };

  return (
    <section
      className="courseDetailHero"
      style={{
        backgroundImage: `linear-gradient(90deg, rgba(5,22,54,0.9) 0%, rgba(5,22,54,0.55) 45%, rgba(5,22,54,0.2) 100%), url(${heroImage})`,
      }}
    >
      <div className="courseDetailHero-inner">
        <h1>{course?.title || "Course title"}</h1>
        <button type="button" className="courseDetailHero-btn" onClick={handleViewDetails}>
          View details
          <span aria-hidden>↓</span>
        </button>
      </div>
    </section>
  );
};

export default CourseDetailHero;
